export const PERMISSION_FACTURACION_ELECTRONICA = "facturacion_electronica";
export const PERMISSION_WHATSAPP_MESSAGING = "whatsapp_messaging";
